import { axiosInstance } from '@configs/axios/axiosInstance';

import type { CreateChangeRequestRequest } from './createChangeRequest.types';

export async function createChangeRequest(
  organizationId: string,
  payload: CreateChangeRequestRequest
): Promise<void> {
  await axiosInstance.post('/change-requests', payload, {
    headers: { 'X-organization-ID': organizationId },
  });
}
